import styled from 'styled-components'
import theme from '../../Common/theme'

export const H2 = styled.h2`
    font-size: ${theme.fontSizes.big};
    font-weight: normal;
    color: ${theme.colors.primary};
`
